import React, { FC, PropsWithChildren } from 'react';
import { Box, BoxProps, defaultColors } from '@lifechurch/react-ion';

type TableProps = {
  testId?: string;
  styles?: BoxProps;
};

const TableBody: FC<PropsWithChildren<TableProps>> = ({ children, styles, testId }) => (
  <Box
    backgroundColor='white'
    borderRadius={2}
    boxShadow={1}
    data-testid={testId}
    py={2}
    {...styles}
  >
    {children}
  </Box>
);

export const BorderedTableBody: FC<PropsWithChildren<TableProps>> = ({
  children,
  styles,
  testId,
}) => (
  <TableBody
    styles={{ boxShadow: 0, border: `1px solid ${defaultColors.gray10}`, ...styles }}
    testId={testId}
  >
    {children}
  </TableBody>
);

export default TableBody;
